import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'profileImgWithNameLetter'
})
export class ProfileImgWithNameLetterPipe implements PipeTransform {

  transform(value: any): string {
    let finalText = "";
    if (value) {
      let splitCharArray: Array<any> = value.split(" ");
      splitCharArray.map((charData: any) => {
        if (charData && charData.trim().length > 0) {
          finalText += (charData.trim()).charAt(0);
        }
      })
    }
    return finalText;
  }

}
